import { render, staticRenderFns } from "./ReFitWizard.vue?vue&type=template&id=116f4af4&scoped=true"
import script from "./ReFitWizard.vue?vue&type=script&lang=js"
export * from "./ReFitWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f4af4",
  null
  
)

export default component.exports